<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 230px'>
        <p>供应商：</p>
        <el-input v-model='awbIpt' size='mini' style='width:150px' placeholder='请输入供应商' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>船舶名称：</p>
        <el-input v-model='nameIpt' size='mini' style='width:150px' placeholder='请输入船舶名称' />
      </div>
      <div class='navContainer'>
        <p>航次：</p>
        <el-input v-model='typeIpt' size='mini' style='width:150px' placeholder='请输入航次' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>状态：</p>
        <el-select v-model='captainIpt' filterable size='mini' style='width:150px'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                     :value='item.value' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 420px'>
        <p style='width: 120px;'>计划开始日期：</p>
        <el-date-picker
          v-model='startDate'
          type='daterange'
          size='mini'
          range-separator='至'
          start-placeholder='开始日期'
          end-placeholder='结束日期'
          value-format='yyyy-MM-dd' />
      </div>
      <div class='navContainer' style='width: 420px'>
        <p style='width: 120px;'>计划结束日期：</p>
        <el-date-picker
          v-model='endDate'
          type='daterange'
          size='mini'
          range-separator='至'
          start-placeholder='开始日期'
          end-placeholder='结束日期'
          value-format='yyyy-MM-dd' />
      </div>
      <div class="navContainer" style="width: 420px">
        <p>实际到港时间：</p>
        <el-date-picker v-model="startTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="endTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange1" type="date" placeholder="结束日期" />
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span='24' class='exportButton' style='text-align: end;'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='supplier' label='供应商' min-width='150' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='shipName' label='船舶名称' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='voyageNumber' label='航次' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='captainName' label='船长姓名' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='captainTel' label='船长电话' min-width='120' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='startPortName' label='出港码头' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='endPortName' label='到港码头' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='loadingNum' label='预装车数量' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='leftoverNum' label='实际装车数量' align='center'
                           :formatter='nullFormat' />
          <el-table-column prop='loadPortName' label='实际装车港口' align='center'
                           show-overflow-tooltip
                           :formatter='nullFormat' />
          <el-table-column prop='unloadPortName' label='实际卸车港口' align='center'
                           show-overflow-tooltip
                           :formatter='nullFormat' />
          <el-table-column prop='brand' label='品牌' align='center'
                           show-overflow-tooltip :formatter='nullFormat' />
          <el-table-column prop='taskType' label='作业类型' align='center'
                           show-overflow-tooltip :formatter='nullFormat' />
          <el-table-column prop='targetShip' label='目标船舶' align='center'
                           show-overflow-tooltip :formatter='nullFormat' width='150' />
          <el-table-column prop='brandCount' label='作业数量' align='center'
                           show-overflow-tooltip :formatter='nullFormat' />
          <!--          <div v-for='i in maxNumber' :key='i'>
                      <el-table-column :prop='`name${i-1}`' label='品牌' min-width='120'
                                       align='center' :formatter='nullFormat' />
                      <el-table-column :prop='`count${i-1}`' label='数量' min-width='120'
                                       align='center' :formatter='nullFormat' />
                    </div>-->
          <el-table-column prop='startTime' label='计划开始时间' align='center'
                           :formatter='timeFormat' />
          <el-table-column prop='endTime' label='计划结束时间' align='center' :formatter='timeFormat' />
          <el-table-column prop='status' label='状态' align='center'>
            <template slot-scope='scope'>{{ getState(scope.row.status) }}</template>
          </el-table-column>
          <el-table-column label='操作' width='170' align='center'>
            <template slot-scope='scope'>
              <div style='align-items:center;'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row)'>详情
                </el-button>
                <el-button size='mini' class='yellow-bg' type='primary'
                           @click='seeMap(scope.row.id)'>地图跟踪
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情车队运输信息' :visible.sync='detailDialogVisible' width='800px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商名称：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>船舶名称：</span>
                <span>{{ detailData.shipName }}</span>
              </div>
              <div>
                <span class='span1'>航次编号：</span>
                <span>{{ detailData.voyageNumber }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>船长姓名：</span>
                <span>{{ detailData.captainName }}</span>
              </div>
              <div>
                <span class='span1'>船长电话：</span>
                <span>{{ detailData.captainTel }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>预装车数量：</span>
                <span>{{ detailData.loadingNum }}</span>
              </div>
              <div>
                <span class='span1'>已装车数量：</span>
                <span>{{ detailData.leftoverNum }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>作业港口</span>
          </div>
          <div class='operationTable'>
            <el-table :data='portData' border>
              <el-table-column prop='taskType' label='任务类型' align='center'>
                <template slot-scope='scope'>{{ taskType(scope.row.taskType) }}</template>
              </el-table-column>
              <el-table-column prop='operationType' label='作业类型' align='center'>
                <template slot-scope='scope'>{{ operationType(scope.row.operationType) }}</template>
              </el-table-column>
              <el-table-column prop='portName' label='作业港口' align='center' />
              <el-table-column prop='arrivalDate' label='进港时间' min-width='130' align='center' />
              <el-table-column prop='taskDate' label='装车时间' min-width='130' align='center' />
              <el-table-column prop='loadingNum' label='作业数量' align='center' />
              <el-table-column label='状态' align='center'>
                <div slot-scope='scope'>{{ getState(scope.row.status) }}</div>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>托运路线</span>
          </div>
          <div style="height:150px;padding-right: 20px;margin: 20px 0;position: relative">
            <routeMap :center="center" v-if="!mapDialogVisible"/>
            <i class="el-icon-zoom-in" style="font-size: 35px;position: absolute;top: 0;right: 36px;cursor: pointer" @click=seeMap></i>
          </div>
        </div> -->
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>委托车信息</span>
          </div>
          <div class='operationTable'>
            <el-table :data='shipData' border>
              <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center' />
              <el-table-column prop='waybillNo' label='运单编号' min-width='130' align='center' />
              <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center' />
              <el-table-column prop='brand' label='品牌' align='center' />
              <el-table-column prop='model' label='型号' min-width='100' show-overflow-tooltip
                               align='center' />
              <el-table-column prop='weight' label='重量' align='center' />
              <el-table-column prop='shipCabinName' label='所在船舱' align='center' />
              <el-table-column prop='startPortName' label='起始港名' align='center' />
              <el-table-column prop='deliveryPortName' label='交车港名' align='center' />
              <el-table-column prop='loadingDate' label='装车时间' align='center'>
                <div slot-scope='scope'>{{ getTime(scope.row.loadingDate) }}</div>
              </el-table-column>
              <el-table-column prop='deliveryDate' label='交车时间' align='center'>
                <div slot-scope='scope'>{{ getTime(scope.row.deliveryDate) }}</div>
              </el-table-column>
              <el-table-column prop='taskType1' label='装车类型' align='center'>
                <div slot-scope='scope'>{{ getTaskType1(scope.row.taskType1) }}</div>
              </el-table-column>
              <el-table-column prop='taskType2' label='正常卸车' align='center'>
                <div slot-scope='scope'>{{ getTaskType1(scope.row.taskType2) }}</div>
              </el-table-column>
              <el-table-column prop='isMassLoss' label='是否质损' align='center'>
                <div slot-scope='scope'>{{ scope.row.isMassLoss == 1 ? '是' : '否' }}</div>
              </el-table-column>
              <el-table-column label='状态' align='center'>
                <div slot-scope='scope'>{{ getState(scope.row.state) }}</div>
              </el-table-column>
            </el-table>
            <div class='paginationContainer' style='margin: 10px 0 0 0'>
              <span>共{{ detail.total }}条</span>
              <el-pagination
                background
                small
                :page-sizes='[10, 20, 30, 40]'
                layout='sizes,prev, pager, next,jumper'
                :total='detail.total'
                :current-page.sync='detail.page'
                @size-change='detailSizeChange'
                @current-change='detailChange'
                @prev-click='detailChange'
                @next-click='detailChange'
              />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='dialogTitle' :visible.sync='mapDialogVisible' width='850px' center>
      <div style='height: 500px;'>
        <!-- 放地图 -->
        <routeMap2 :center='center' :line-arr='lineArr' v-if='mapDialogVisible' ref='routeMap2' />
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    shipDeployDetail,
    vehicleDetailPageList,
    trackPageList,
    waterShipLocation,
  } from '@/service/vehiclelog';
  import routeMap from '@/components/routeMap';
  import { formatTime, getSessionStore } from '@/config/mUtils';
  import { formatDateTime } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';

  export default {
    components: {
      routeMap,
      routeMap2: routeMap,
    },
    data() {
      return {
        awbIpt: '',
        nameIpt: '',
        typeIpt: '',
        captainIpt: '',
        startDate: ['', ''],
        endDate: ['', ''],
        startTime: '',
        endTime: '',
        stateOption: [{
          value: '',
          label: '全部',
        }, {
          value: '1',
          label: '航行中',
        }, {
          value: '2',
          label: '已完成',
        }],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        detailDialogVisible: false,
        detailData: {},
        shipData: [],
        portData: [],
        detail: {
          page: 1,
          total: 0,
          size: 10,
        },

        mapDialogVisible: false,
        dialogTitle: '',
        center: '',//委托车当前位置
        lineArr: '',//委托车路线
        maxNumber: 0,
      };
    },
    filters: {
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
        } else {
          return '';
        }
      },
    },
    computed: {
      taskType() {
        return function(state) {
          switch (state) {
            case 0:
              return '正常作业';
            case 1:
              return '过驳';
            case 2:
              return '转船';
          }
        };
      },
      operationType() {
        return function(state) {
          switch (state) {
            case 0:
              return '装车';
            case 1:
              return '卸车';
          }
        };
      },
      portStatus() {
        return function(state) {
          switch (state) {
            case 0:
              return '待执行';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
          }
        };
      },
      getTime() {
        return function(time) {
          return formatDateTime(time, 'yyyy-mm-dd');
          // return formatDateTime(time,'yyyy-mm-dd hh:ii:ss')
        };
      },
    },
    mounted() {
    //  this._trackPageList();
    },
    methods: {
      nullFormat(r, c, cellValue) {
        return cellValue ? cellValue : '--';
      },
      timeFormat(r, c, cellValue) {
        return cellValue.slice(0, 10);
      },
      async _trackPageList() {
        this.tableLoad = true;
        const res = await trackPageList(
          {
            supplierName: this.awbIpt,
            shipName: this.nameIpt,
            voyageNumber: this.typeIpt,
            startPlanDate: this.startDate[0] ? this.startDate[0] : '',
            endPlanDate: this.startDate[1] ? this.startDate[1] : '',
            startOverDate: this.endDate[0] ? this.endDate[0] : '',
            endOverDate: this.endDate[1] ? this.endDate[1] : '',
            startTime: this.startTime,
            endTime: this.endTime,
            status: this.captainIpt,
            rows: this.size,
            page: this.page,
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.maxNumber = res.data.records[0].maxNumber;
        this.total = res.data.total;
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._trackPageList();
      },
      contractCurrentChange(page) {
        this.page = page;
        this._trackPageList();
      },
      // 详情
      async detailClick(row) {
        this.detail.page = 1;
        this.detail.id = row.id;
        this.detailDialogVisible = true;
        const res = await shipDeployDetail(row.id);
        console.log(res);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data.detailData;
        this.portData = res.data.detailData.portList;
        await this._carPageList();
      },
      // 详情 —— 分页查询
      async _carPageList() {
        let obj = {
          basicId: this.detail.id,
          rows: this.detail.size,
          page: this.detail.page,
        };
        const res = await vehicleDetailPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.shipData = res.data.records;
        this.detail.total = res.data.total;
      },
      // 详情 —— 分页大小改变
      detailSizeChange(size) {
        // 每页条数
        this.detail.size = size;
        this._carPageList();
      },
      // 详情 —— 当前页改变
      detailChange(page) {
        // 翻页
        this.detail.page = page;
        this._carPageList();
      },
      // 托运路线
      seeMap(id) {
        this.dialogTitle = '托运路线';
        waterShipLocation(id)
          .then((res) => {
            if (res.status !== 0) return this.$message.error(res.message);
            this.center = res.data[0];
            this.lineArr = res.data;
            this.mapDialogVisible = true;
            this.$nextTick(() => {
              this.$refs.routeMap2.startAnimation();
            });
          });
      },
      // 实际到港时间开始-结束日期验证
      dateChange1(val) {
        if (this.endTime && this.startTime && this.endTime <= this.startTime) {
          if (val == this.endTime) this.endTime = '';
          if (val == this.startTime) this.startTime = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      searchBtn() {
        const isStartDate = Date.parse(this.startDate[0]);
        const isEndDate = Date.parse(this.endDate[0]);
        if (!isStartDate && !isEndDate) return  this.$message.warning('请选择计划开始时间或者计划结束时间！');
        this.page = 1;
        this._trackPageList();
      },
      resetBtn() {
        this.awbIpt = '';
        this.nameIpt = '';
        this.typeIpt = '';
        this.captainIpt = '';
        this.startDate = ['', ''];
        this.endDate = ['', ''];
      },

      // 装车类型
      getTaskType1(val) {
        switch (val) {
          case 0:
            return '正常装车';
          case 1:
            return '过驳 ';
          case 2:
            return '转船';
        }
      },
      // 卸车类型
      getTaskType2(val) {
        switch (val) {
          case 0:
            return '正常卸车';
          case 1:
            return '过驳 ';
          case 2:
            return '转船';
        }
      },
      // 状态
      getState(state) {
        switch (state) {
          case 1:
            return '航行中 ';
          case 2:
            return '已完成';
        }
      },
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/shipDeploy/export?access_token=${token}&supplierName=${this.awbIpt}&shipName=${this.nameIpt}&voyageNumber=${this.typeIpt}&status=${this.captainIpt}&startPlanDate=${this.startDate[0] ? this.startDate[0] : ''}&endPlanDate=${this.startDate[1] ? this.startDate[1] : ''}&startOverDate=${this.endDate[0] ? this.endDate[0] : ''}&endOverDate=${this.endDate[1] ? this.endDate[1] : ''}`;
        window.exportExcelGet('/platform/shipDeploy/export', `supplierName=${this.awbIpt}&shipName=${this.nameIpt}&voyageNumber=${this.typeIpt}&status=${this.captainIpt}&startPlanDate=${this.startDate[0] ? this.startDate[0] : ''}&endPlanDate=${this.startDate[1] ? this.startDate[1] : ''}&startOverDate=${this.endDate[0] ? this.endDate[0] : ''}&endOverDate=${this.endDate[1] ? this.endDate[1] : ''}&startTime=${this.startTime ? this.startTime: ''}&endTime=${this.endTime ? this.endTime: ''}`);
      },
    },
  };
</script>

<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 70px;
        text-align: right;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-table .ui-warning-row {
      background: #DDD !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
</style>
